import React from 'react'
import {Router, Route, Switch} from 'react-router-dom'
import history from './history'
import PrivateRoute from './privateRouter'
import App from '../pages/App'
import Login from '../pages/login'
import CallBack from '../pages/callback'
import * as AppUrl from '../constants/appUrl'
import {IntlProvider} from 'react-intl'
import NoPermission from '../components/common/403'

const lang = 'en'

class BaseRouter extends React.Component {
  render() {
    return (
      <IntlProvider locale={lang}>
        <Router history={history}>
          <Switch>
            <Route exact path={AppUrl.FORBIDDEN} component={NoPermission}/>
            <Route exact path="/callback" component={CallBack}/>
            <Route exact path={'/login'} component={Login}/>
            <PrivateRoute path="/" component={App}/>
          </Switch>
        </Router>
      </IntlProvider>
    )
  }
}

export default BaseRouter
